var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/sub_navigation.tsx";
// import throttle from 'lodash/throttle';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
// import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

// import { openModal } from 'soapbox/actions/modals';
// import { useAppDispatch } from 'soapbox/hooks';

import { CardHeader, CardTitle } from './ui';
const messages = defineMessages({
  back: {
    "id": "column_back_button.label",
    "defaultMessage": "Back"
  },
  settings: {
    "id": "column_header.show_settings",
    "defaultMessage": "Show settings"
  }
});
const SubNavigation = ({
  message,
  children,
  className
}) => {
  const intl = useIntl();
  const history = useHistory();
  const handleBackClick = () => {
    if (window.history && window.history.length === 1) {
      history.push('/');
    } else {
      history.goBack();
    }
  };
  return /*#__PURE__*/React.createElement(CardHeader, {
    className: className,
    "aria-label": intl.formatMessage(messages.back),
    onBackClick: handleBackClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  }, !children ? /*#__PURE__*/React.createElement(CardTitle, {
    title: message,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 21
    }
  }) : children);
};
export default SubNavigation;